import { SET_PANEL, SET_CONTENT_URL } from './mutation-types';

const actions = {
    setPanels ({ dispatch }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    setContentUrl ({ commit}, {...params}){
        commit(SET_CONTENT_URL, {...params});
    },
};

export default actions;
